import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Stack, Typography } from '@mui/material';
import { Markup } from 'interweave';
import { CloseIconButton, CustomTitle } from './DialogStyled.js';

export default function AiqDialog({
    title,
    text,
    open,
    onClose,
    showDefaultActions = true,
    children,
    sx,
    icon,
    sxTitle,
    sxTitleText,
    sxCloseButton,
    closeIconColor,
    sxContent,
    sxCloseText,
    confirmaitonModalActions = false,
    confirmAction,
    buttonTextConfirm,
    cancelText,
    hasTitle = true,
    returnToQueueError,
    isDisabled,
    editTransactionModal = false,
}) {
    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                zIndex: 10003,
                ...(sx || {
                    '& [class^="MuiPaper"]': {
                        maxWidth: '750px',
                        maxHeight: '95vh',
                        padding: '.5rem',
                    },

                    '& h2': {
                        textAlign: 'center',
                        marginBottom: '0.5rem',
                    },
                    '& p[class^="MuiDialogContentText"]': {
                        padding: '0 0 2rem 1rem',
                    },
                }),
            }}
        >
            <Box>
                {hasTitle && (
                    <CloseIconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            ...sxCloseButton,
                            color: closeIconColor,
                        }}
                    >
                        <CloseIcon />
                    </CloseIconButton>
                )}
                {title && (
                    <CustomTitle sx={sxTitle}>
                        <Stack direction="row" alignItems="center" spacing={2}>
                            {icon}
                            <Typography id="alert-dialog-title" sx={sxTitleText}>
                                {title}
                            </Typography>
                        </Stack>
                    </CustomTitle>
                )}
            </Box>
            <DialogContent sx={sxContent}>
                {text && (
                    <DialogContentText id="alert-dialog-description">
                        <Markup content={text} />
                    </DialogContentText>
                )}
                {children}
            </DialogContent>
            {showDefaultActions && (
                <DialogActions>
                    <Button
                        sx={{
                            ...sxCloseText,
                            color: '#1870EB',
                        }}
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </DialogActions>
            )}
            {confirmaitonModalActions && (
                <DialogActions sx={[returnToQueueError && { flexDirection: 'column' }]}>
                    <Button
                        sx={{
                            color: editTransactionModal ? '#5C5D6A ' : '#1870EB',
                            ...(returnToQueueError && { marginBottom: '8px' }),
                            ...(returnToQueueError && { color: 'white' }),
                        }}
                        variant={returnToQueueError ? 'contained' : 'text'}
                        onClick={handleClose}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        sx={[editTransactionModal && { margin: '8px' }, returnToQueueError && { color: '#1870EB' }]}
                        variant={(editTransactionModal && 'outlined') || (returnToQueueError ? 'text' : 'contained')}
                        color={editTransactionModal ? 'error' : 'primary'}
                        onClick={confirmAction}
                        disabled={isDisabled}
                    >
                        {buttonTextConfirm()}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
}
